import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { formatDateTime } from '../services/date';

const TYPE_BADGE = {
  informational: { label: 'Informational', className: 'border-2 border-blue-500 text-blue-500' },
  maintenance: { label: 'Maintenance', className: 'border-2 border-red-800 text-red-800' },
};

function getTypeBadge(type) {
  const key = (type || 'maintenance').toLowerCase();
  return TYPE_BADGE[key] || TYPE_BADGE['maintenance'];
}

const MaintenanceCard = ({ maintenance, onEdit, onArchive, onErase }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const badge = getTypeBadge(maintenance.type);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="py-4 -mx-4 px-4 hover:bg-gray-50 border-b border-gray-200">
      <div className="flex justify-between items-start">
        <div className="flex-grow">
          <div className="flex items-center gap-2 mt-2 mb-1">
            <p className="text-2xl font-bold text-black">{maintenance.title}</p>
            <span className={`text-sm font-bold px-2.5 py-1 rounded-none ${badge.className}`}>
              {badge.label}
            </span>
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <p><strong>Starts:</strong> {formatDateTime(maintenance.start_time)} {maintenance.ongoing ? '(Ongoing)' : (maintenance.end_time ? <>| <strong>Ends:</strong> {formatDateTime(maintenance.end_time)}</> : '')}</p>
            {onErase && maintenance.archive_date && <p><strong>Archived:</strong> {formatDateTime(maintenance.archive_date)}</p>}
            {isExpanded && (
              <div className="prose prose-sm max-w-full mt-2 text-gray-700">
                <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>{maintenance.most_recent_update}</ReactMarkdown>
              </div>
            )}
            <button onClick={toggleExpanded} className="text-blue-500 hover:underline mt-2">
              {isExpanded ? 'View Less' : 'View More'}
            </button>
            {maintenance.clusters && maintenance.clusters.length > 0 && (
              <p className="text-sm text-gray-600 mt-2">
                <span className="font-semibold">Affected Clusters:</span> {maintenance.clusters.join(', ')}
              </p>
            )}
          </div>
        </div>
        <div className="flex flex-col items-end ml-6">
          {onErase ? (
            <button
              onClick={() => onErase(maintenance)}
              className="ml-2 px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800"
            >
              Erase
            </button>
          ) : (
            <>
              <button
                onClick={() => onEdit(maintenance)}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => onArchive(maintenance)}
                className="mt-2 px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
              >
                Archive
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceCard;
